import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import Ui from 'ui'

function BuilderSummaryEditProps() {
  const { setIsEditingDescription } = React.useContext(FormBuilderContext)

  function onEditDescriptionQuestion() {
    setIsEditingDescription(true)
  }

  return (
    <Ui.ButtonClear
      className="border text-sm"
      onClick={onEditDescriptionQuestion}
    >
      Edit template
    </Ui.ButtonClear>
  )
}

export default BuilderSummaryEditProps
